const initialState = {
  email: ""
}

export default function (state = initialState, action) {
    switch (action.type) {
        case 'LOGIN_FORM_EMAIL':
            return {
              email: action.payload
            };
            break;
        default:
            return state
    }
    return state;
}



// WEBPACK FOOTER //
// ./src/services/userDetails/reducer_email.js